import React from 'react';
import {useSelector} from 'react-redux';
import {ScrollView, Text, View} from 'react-native';

//////////////////////////
///////  components
import ChallengesList from 'src/ScavengerHunt_v2/Classic/ChallengesList';

import HuntOutro from 'src/ScavengerHunt_v2/Game/HuntOutro';
import {useLocation} from '../../Hooks/gameHooks';
import {ProgressBar} from '../Classic/Header';
import {InLineIconButton} from '../../Modules/CommonView/Buttons';
import {navigationRef} from '../../Nav/navigationHelpers';

const LocationChallenges = () => {
  const timerFinish = useSelector((state) => state.game_v2?.timerFinish);

  const groupInfo = useSelector((state) => state.groupInfo || {});

  const {groupPhoto} = groupInfo;

  if (timerFinish) {
    return <HuntOutro />;
  }

  const location = useLocation();
  const {challengeList = [], photoLarge} = location;
  const allChallenges = useSelector((state) => state.game_v2?.allChallenges);

  const availableChallenges = [];

  const completedChallenges = [];

  !!challengeList?.length &&
    challengeList.forEach((key) => {
      const locationChallenge = allChallenges[key] || {};
      const isDone =
        locationChallenge?.completeTime || locationChallenge?.photoUrl;
      console.log({locationChallenge, isDone});
      if (isDone) {
        completedChallenges.push(locationChallenge);
      } else {
        availableChallenges.push(locationChallenge);
      }

      // combinedChallenges.push(key);
    });

  const challengeCompletionPercent =
    5 + Math.max(5, (100 * completedChallenges?.length) / challengeList.length);

  console.log({
    availableChallenges,
    completedChallenges,
    challengeCompletionPercent,
  });

  const basePhotoUrl = 'photos.letsroam.com';
  const largeDisplayedPhoto = photoLarge
    ? `https://${basePhotoUrl}${photoLarge && photoLarge.substring(1)}`
    : groupPhoto;

  return (
    <View style={{flex: 1, backgroundColor: global?.color?.white1}}>
      <ScrollView style={{flex: 1}}>
        <View
          style={{
            flexDirection: 'row',
            marginHorizontal: 10,
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: 30,
          }}>
          {!!challengeList.length && (
            <ProgressBar
              percentage={challengeCompletionPercent}
              size={140}
              centerImageUrl={largeDisplayedPhoto}
              handlePress={() =>
                navigationRef.navigate('FullScreenNavigationHelpModal')
              }
              // handlePress={() => navigationRef.navigate('PlayerDashboard_v2')}
            />
          )}
          <View style={{flex: 1, marginLeft: 16}}>
            <Text
              style={{
                fontFamily: 'JakartaBold',
                fontSize: 24,
                lineHeight: 29,
                marginTop: 10,
                marginBottom: 10,
              }}
              ellipsizeMode="tail">
              {location?.name}
            </Text>
            <View>
              <InLineIconButton
                handlePress={() =>
                  navigationRef.navigate('FullScreenNavigationHelpModal')
                }
                text={`See map`}
                icon="map"
                color="orange"
                inline
              />
            </View>
          </View>
        </View>
        <View style={{flex: 1, paddingBottom: 60}}>
          <ChallengesList
            availableChallenges={availableChallenges}
            completedChallenges={completedChallenges}
            challengeHeader={'Site Challenges'}
            challengeHeaderStyle={{
              textAlign: 'left',
              fontSize: 24,
              lineHeight: 29,
              fontFamily: 'JakartaBold',
            }}
            challengeHeaderBody={
              'Complete all the challenges here to move on. Earn points for speed and accuracy at each site.'
            }
            challengeHeaderBodyStyle={{
              textAlign: 'left',
              fontSize: 15,
              lineHeight: 21,
              fontFamily: 'Jakarta',
              marginHorizontal: 20,
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
};

export default LocationChallenges;
